getPmSectionErrorCreated